export default "__VITE_ASSET__B2os75gx__"